import { AppState } from "src/states/appState"; import * as api from "src/api";
import { DefaultDatasetQuery, DatasetQuery } from "src/model/DatasetQuery";
import { OVERVIEW_ERROR, OVERVIEW_LOADING, OVERVIEW_SUCCESS } from "src/reducers/overviewReducer";


export const loadOverview=()=>async(dispatch:any,getState:()=>AppState)=>{
  
  dispatch({type:OVERVIEW_LOADING});
  
  const { apiServerUrl } = getState().configState;
  const userId = getState().sessionState.user?.id ?? '';
  const q:DatasetQuery={ ...DefaultDatasetQuery, offset:1, count:10000000000, shallow:'yes', geojson:false };

  try{
    const [ocdbDatasets, fidraddbDatasets] = await Promise.all([
      api.findDatasets(apiServerUrl, q, userId),
      api.getFidraddbFiles(apiServerUrl),
    ]);
    dispatch({type:OVERVIEW_SUCCESS, payload:{ ocdbDatasets, fidraddbDatasets }});
  }
  catch(e){ 
    dispatch({type:OVERVIEW_ERROR, error:String(e)}); 
  }
};
